const getSiteTheme = () => document.documentElement.getAttribute("data-theme") || "default";

export const isDarkTheme = () => {
  return getSiteTheme() === "dark";
};
